import queryLoopLoaded from "@plaudit/query-loop.api";

import QueryLoopFormFieldBase from "./QueryLoopFormFieldBase";

export class ConstantOrPassthroughQueryLoopFormField extends QueryLoopFormFieldBase {
	private valueCache: string|undefined = undefined;

	public constructor(field: HTMLFieldSetElement, type: string) {
		super(field, type);
		this.postConstruct();
	}

	public getValue(): string|string[] {
		if (this.valueCache !== undefined) {
			return this.valueCache;
		}
		const dataValue = this.field.getAttribute('data-value');
		if (dataValue === null) {
			console.error("Encountered a null data value. This should not be possible.");
			return this.valueCache = "";
		}
		const res = JSON.parse(dataValue);
		if (res === null || res === undefined) {
			console.error(`Encountered a ${res === null ? "null" : "undefined"} data value. This should not be possible.`);
			return this.valueCache = "";
		}
		return this.valueCache = (Array.isArray(res) ? res.map(r => r.toString()) : res.toString());
	}
	public setValue(value: string|string[]) {
		return false;
	}

	public loadIntoQuery(params: URLSearchParams) {
		const value = this.getValue();
		if (typeof value === 'string') {
			params.set(this.name, value);
		} else {
			for (let i = 0; i < value.length; i++) {
				params.set(`${this.name}[${i}]`, value[i]);
			}
		}
		return false;
	}
	public loadFromQuery(params: URLSearchParams) {
		return false;
	}

	public getLabeledValues() {
		return [];
	}

	protected getDefaultValue(): string|string[] {
		return this.getValue();
	}

	public isTrackedInQuery() {
		return false;
	}
	public isSingleValued() {
		return !Array.isArray(this.getValue());
	}
	public isInQuery() {
		return false;
	}
}

queryLoopLoaded.then(() => {
	plaudit.queryLoop.fieldTypes.set('constant', field => new ConstantOrPassthroughQueryLoopFormField(field, 'constant'));
	plaudit.queryLoop.fieldTypes.set('passthrough', field => new ConstantOrPassthroughQueryLoopFormField(field, 'passthrough'));
});
